<template>
  <div @click.stop.prevent="$emit('close')" class="modal-back">
    <div @click.stop class="modal-inner">
      <div
        class="close-btn"
        @click="$emit('close')"
        data-shortcut-esc="palettePopup"
      >
        <span></span>
      </div>
      <h2>リンク</h2>
      <div>
        <label v-if="selectLinkKind">リンク</label>
        <div v-if="selectLinkKind" class="common-select">
          <select
            :value="attrs['data-link-kind']"
            @change="onChangeKind"
            :disabled="!selectLinkKind"
          >
            <option
              v-for="kind in kindList"
              :key="kind.value || 1"
              :value="kind.value"
            >
              {{ kind.text }}
            </option>
          </select>
        </div>
        <!-- web -->
        <div v-if="attrs['data-link-kind'] === 'web'">
          <div>
            <label>WebサイトURL</label>
            <div class="common-input">
              <input
                type="text"
                :value="attrs.href"
                @input="setLocalAttr($event, 'href')"
                placeholder="https://"
              />
            </div>
          </div>
          <button
            @click="isShowExtraOption = !isShowExtraOption"
            class="easy-link"
          >
            高度な設定
          </button>
          <button
            @click="removeLink"
            class="easy-link"
          >
            リンク削除
          </button>
          <div v-if="isShowExtraOption">
            <div>
              <label>
                <input
                  type="checkbox"
                  :checked="attrs.target === '_blank'"
                  @change="onChangeTarget"
                />
                別ウィンドウで開く
              </label>
            </div>
            <div>
              <label>タイトル</label>
              <div class="common-input">
                <input
                  type="text"
                  :value="attrs.title"
                  @input="setLocalAttr($event, 'title')"
                />
              </div>
            </div>
          </div>
        </div>
        <!-- web -->
        <!-- email -->
        <div v-if="attrs['data-link-kind'] === 'email'">
          <div>
            <label>メールアドレス</label>
            <div class="common-input">
              <input
                type="text"
                :value="email.to"
                @input="setEmailInfo($event, 'to')"
              />
            </div>
          </div>
          <div>
            <label>メールタイトル</label>
            <div class="common-input">
              <input
                type="text"
                :value="email.subject"
                @input="setEmailInfo($event, 'subject')"
              />
            </div>
          </div>
          <div>
            <label>メール本文</label>
            <textarea
              type="text"
              class="common-input textarea"
              :value="email.body"
              @input="setEmailInfo($event, 'body')"
            />
          </div>
          <button
            @click="removeLink"
            class="easy-link"
          >
            リンク削除
          </button>
        </div>
        <!-- email -->
        <!-- tel -->
        <div v-if="attrs['data-link-kind'] === 'tel'">
          <div>
            <label>電話番号</label>
            <div class="common-input">
              <input
                type="text"
                :value="telNumber"
                @input="setTelNumber($event)"
              />
            </div>
          </div>
          <button
            @click="isShowExtraOption = !isShowExtraOption"
            class="easy-link"
          >
            高度な設定
          </button>
          <button
            @click="removeLink"
            class="easy-link"
          >
            リンク削除
          </button>
          <div v-if="isShowExtraOption">
            <div>
              <label>タイトル</label>
              <div class="common-input">
                <input
                  type="text"
                  :value="attrs.title"
                  @input="setLocalAttr($event, 'title')"
                />
              </div>
            </div>
          </div>
        </div>
        <!-- tel -->
        <div class="button-box">
          <button @click="insertLink" class="normal-btn ok">OK</button>
          <button @click="$emit('close')" class="normal-btn cancel">キャンセル</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { parseMailHref, assembleMailHref, validateLink } from '@/utils/String'
import ShortCutBase from '@/mixins/ShortCutBase'

export default {
  mixins: [
    ShortCutBase,
  ],
  props: [
    'ids',
    'defaultAttrs',
    'partsContainerType',
  ],
  data () {
    return {
      kindList: [
        { text: '未設定', value: null },
        { text: 'WebサイトURL', value: 'web' },
        { text: 'メールアドレス', value: 'email' },
        { text: '電話番号', value: 'tel' },
      ],
      attrs: {
        'data-link-kind': null,
        href: null,
        target: '_top',
        title: null,
      },
      email: {
        to: '',
        subject: '',
        body: '',
      },
      telNumber: '',
      isShowExtraOption: false,
    }
  },
  mounted () {
    this.attrs = { ...this.attrs, ...this.defaultAttrs }
    if (!this.defaultAttrs || !this.defaultAttrs['data-link-kind']) {
      // デフォルトはwebに
      this.attrs['data-link-kind'] = 'web'
    }
    if (this.defaultAttrs && this.defaultAttrs['data-link-kind'] === 'email') {
      this.email = { ...parseMailHref(this.attrs.href) }
    }
    if (this.defaultAttrs && this.defaultAttrs['data-link-kind'] === 'tel') {
      this.telNumber = this.attrs.href.replace(/^tel:/g, '')
    }
  },
  computed: {
    // パーツコンテナがフォローボタン・シェアボタン以外の場合、リンク種類を選択可能
    selectLinkKind () {
      if (!this.partsContainerType) return null
      return (this.partsContainerType !== 'FollowButton') && (this.partsContainerType !== 'Share')
    }
  },
  methods: {
    onChangeKind (event) {
      this.attrs = {
        'data-link-kind': event.target.value,
        href: null,
        target: '_top',
        title: null,
      }
      this.email = {
        to: '',
        subject: '',
        body: '',
      }
      this.telNumber = ''
    },
    setLocalAttr (event, key) {
      this.attrs[key] = event.target.value
    },
    setEmailInfo (event, key) {
      this.email[key] = event.target.value
    },
    setTelNumber (event) {
      this.telNumber = event.target.value
    },
    onChangeTarget (event) {
      this.attrs.target = (event.target.checked) ? '_blank' : '_top'
    },
    removeLink () {
      this.telNumber = null
      this.attrs.href = null
      this.email = {
        to: '',
        subject: '',
        body: '',
      }
    },
    insertLink () {
      if ((this.attrs['data-link-kind'] === 'web' && !this.attrs.href) ||
          (this.attrs['data-link-kind'] === 'email' && !this.email.to && !this.email.subject && !this.email.body) ||
          (this.attrs['data-link-kind'] === 'tel' && !this.telNumber)) {
        // 空欄の場合 リンク削除時に未設定に戻す
        this.attrs = {
          'data-link-kind': null,
          href: null,
          target: '_top',
          title: null,
        }
        this.email = {
          to: '',
          subject: '',
          body: '',
        }
        this.telNumber = ''
      } else {
        // validation
        const errorMessages = validateLink(
          this.attrs['data-link-kind'], {
            webLink: this.attrs.href,
            webTitle: this.attrs.title,
            emailTo: this.email.to,
            emailSubject: this.email.subject,
            emailBody: this.email.body,
            telNumber: this.telNumber,
            telTitle: this.attrs.title
          }
        )
        if (errorMessages.length > 0) return this.$store.commit('showErrorMessagePopup', errorMessages)
        // 後処理
        if (this.attrs['data-link-kind'] === 'email') {
          this.attrs.href = assembleMailHref(this.email.to, this.email.subject, this.email.body)
        }
        if (this.attrs['data-link-kind'] === 'tel') {
          this.attrs.href = `tel:${this.telNumber}`
        }
      }
      // コードパーツの場合とそれ以外で処理を分ける
      if (this.partsContainerType === 'Code') {
        this.$emit('changeCodePartLink', {
          attrs: this.attrs
        })
      } else {
        this.$store.commit('updatePart', {
          ...this.ids,
          attrs: this.attrs
        })
      }
      this.$emit('close')
    },
  },
}
</script>

<style lang="scss" scoped>
.modal-inner {
  color: $commonFontColor;
  width: 400px;
  background:#F8F8F8;
  border-radius: 2px;
  padding: 10px 20px 20px;
  box-shadow: 0 3px 4px rgba(32, 32, 32, 0.3);
  position: relative;
  .close-btn {
    position: absolute;
    display: inline-block;
    width: 35px;
    height: 35px;
    top: 5px;
    right: 5px;
    border: none;
    cursor: pointer;
    background: none;
    outline: none;
    span::before, span::after {
      display: block;
      content: '';
      position: absolute;
      top: 50%;
      left: 50%;
      width: 20px;
      height: 2px;
      border-radius: 2px;
      margin: -1px 0 0 -13px;
      background: #555;
    }
    span::before {
      transform: rotate(-45deg);
    }
    span::after {
      transform: rotate(45deg);
    }
    &:hover {
      opacity: 0.7;
    }
  }
  h2 {
    border-bottom: 1px solid #dbdbdb;
    line-height: 2;
  }
  label {
    display: block;
    font-size: 14px;
    margin: 20px 0 5px;
  }
  .common-input {
    width: 400px;
    padding: 5px 10px 3px 10px;
  }
  .button-box {
    display: flex;
    justify-content: center;
    button {
      font-size: 14px;
      border: solid 1px #c6c6c6;
      border-radius: 5px;
      &:hover {
        opacity: 0.8;
      }
      &.ok {
        margin-right: 20px;
        color: #fff;
        border: solid 1px #484848;
        background: #484848;
      }
    }
  }
  .textarea {
    height: 120px;
  }
  .easy-link {
    color: #3192e0;
    text-decoration: underline;
    user-select: none;
    margin-bottom: 30px;
    cursor: pointer;
    &:first-of-type {
      margin-right: 10px;
    }
  }
}
</style>
